import React, { Component, Fragment } from 'react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Badge from '@material-ui/core/Badge'

import NotificationIcon from '@material-ui/icons/Notifications'
import FavoriteIcon from '@material-ui/icons/Favorite'
import ChatIcon from '@material-ui/icons/Chat'

import { connect } from 'react-redux'
import { markNotificationsRead } from '../../redux/actions/userAction'
import { Link } from 'react-router-dom'


class Notifications extends Component {
    state = {
        anchorEl: null
    }

    handleOpen = event => {
        this.setState({
            anchorEl: event.target
        })
    }
    handleClose = () => {
        this.setState({
            anchorEl: null
        })
    }

    onMenuOpen = () => {
        let unreadNotificationsIds = this.props.notifications.filter(not => !not.read).map(not => not.notificationId)
        this.props.markNotificationsRead(unreadNotificationsIds)
    }
    render() {
        dayjs.extend(relativeTime)
        const notifications = this.props.notifications
        const anchorEl = this.state.anchorEl
        let notificationsIcon
        if (notifications && notifications.length > 0) {
            notifications.filter(not => not.read === false).length > 0 ?
                (notificationsIcon = (
                    <Badge badgeContent={notifications.filter(not => not.read === false).length}
                        color='secondary'>
                        <NotificationIcon />
                    </Badge>
                ))
                : notificationsIcon = <NotificationIcon />
        } else notificationsIcon = <NotificationIcon />
        let notificationsMarkUp = notifications && notifications.length > 0 ?
            notifications.map(not => {
                const verb = not.type === 'like' ? 'liked' : 'commented on'
                const time = dayjs(not.createdAt).fromNow()
                const color = not.read ? 'primary' : 'secondary'
                const icon = not.type === 'like' ?
                    <FavoriteIcon color={color} style={{ marginRight: 10 }} />
                    :
                    <ChatIcon color={color} style={{ marginRight: 10 }} />
                return (<MenuItem key={not.createdAt} onClick={this.handleClose}>
                    {icon}
                    <Typography component={Link}
                        color='primary'
                        variant='body1'
                        to={`/users/${not.recipient}/scream/${not.screamId}`}>
                        {not.sender} {verb} your scream {time}
                    </Typography>
                </MenuItem >)
            }) :
            <MenuItem onClick={this.handleClose}>
                You have no notifications yet
            </MenuItem>
        return (
            <Fragment>
                <Tooltip placement='top' title='notifications'>
                    <IconButton aria-owns={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup='true'
                        onClick={this.handleOpen} >
                        {notificationsIcon}
                    </ IconButton >
                </Tooltip>
                <Menu anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClick={this.handleClose}
                    onEntered={this.onMenuOpen}>
                    {notificationsMarkUp}
                </Menu>
            </Fragment>
        )
    }
}
let mapStateToProps = state => ({
    notifications: state.user.notifications
})
export default connect(mapStateToProps, { markNotificationsRead })(Notifications)